import { useMutation, useQueryClient } from '@tanstack/react-query';
import ResourceService from '../Services/resources/ResourceService';
import { toast } from 'sonner';
import { GET_RESOURCES_QUERY_KEY } from '../queries/useGetResources';

export const useResourceMutations = () => {
  const queryClient = useQueryClient();

  const uploadPdfFilesMutation = useMutation({
    mutationFn: (pdfFilesData) => ResourceService.uploadPdfFiles(pdfFilesData),
    onSuccess: () => {
      queryClient.invalidateQueries([GET_RESOURCES_QUERY_KEY]);
      toast.success("Fichiers PDF téléchargés avec succès");
    },
    onError: (error) => {
      toast.error(`Échec du téléchargement : ${error.message}`);
    },
  });
  
  const deletePdfFileMutation = useMutation({
    mutationFn: (pdfFileId) => ResourceService.deletePdfFile(pdfFileId),
    onSuccess: () => {
      queryClient.invalidateQueries([GET_RESOURCES_QUERY_KEY]);
      toast.success("Fichier PDF supprimé avec succès");
    },
    onError: (error) => {
      toast.error(`Échec de la suppression : ${error.message}`);
    },
  });
  const downloadPdfFileMutation = useMutation({
    mutationFn: (pdfFileId) => ResourceService.downloadPdfFile(pdfFileId),
    onSuccess: () => {
      toast.success("Fichier PDF téléchargé avec succès");
    },
    onError: (error) => {
      toast.error(`Échec du téléchargement : ${error.message}`);
    },
  });

  const generateSecureViewUrlMutation = useMutation({
    mutationFn: (pdfFileId) => ResourceService.generateSecureViewUrl(pdfFileId),
    onSuccess: (data) => {
      // Open the secure URL in a new tab
      if (data.secure_url) {
        // Check if URL is expired
        if (data.expires_at) {
          const expirationTime = new Date(data.expires_at);
          const now = new Date();
          
          if (expirationTime <= now) {
            toast.error('Le lien de visualisation a expiré. Veuillez réessayer.');
            return;
          }
          
          // Calculate time until expiration for user feedback
          const timeUntilExpiration = Math.floor((expirationTime - now) / 1000 / 60); // minutes
          if (timeUntilExpiration < 10) {
            toast.warning(`Le lien expirera dans ${timeUntilExpiration} minute(s)`);
          }
        }
        
        // // Store session_id in localStorage for potential future use (optional)
        // if (data.session_id) {
        //   localStorage.setItem(`pdf_session_${data.session_id}`, JSON.stringify({
        //     expiresAt: data.expires_at,
        //     pdfTitle: data.pdf_title
        //   }));
          
        //   // Clean up expired sessions
        //   const keys = Object.keys(localStorage);
        //   keys.forEach(key => {
        //     if (key.startsWith('pdf_session_')) {
        //       try {
        //         const sessionData = JSON.parse(localStorage.getItem(key));
        //         if (sessionData.expiresAt && new Date(sessionData.expiresAt) <= new Date()) {
        //           localStorage.removeItem(key);
        //         }
        //       } catch (e) {
        //         // Remove invalid session data
        //         localStorage.removeItem(key);
        //       }
        //     }
        //   });
        // }
        
        window.open(data.secure_url, '_blank', 'noopener,noreferrer');
        toast.success(`Ouverture de "${data.pdf_title}" dans un nouvel onglet`);
      } else {
        toast.error('URL sécurisée non générée');
      }
    },
    onError: (error) => {
      console.error('PDF view error:', error);
      
      // Handle specific error messages
      if (error.message.includes('Authentication required')) {
        toast.error('Session expirée. Veuillez vous reconnecter.');
      } else if (error.message.includes('Access denied')) {
        toast.error('Accès refusé. Vérifiez votre abonnement et vos permissions.');
      } else if (error.message.includes('PDF file not found')) {
        toast.error('Fichier PDF introuvable.');
      } else if (error.message.includes('Server error')) {
        toast.error('Erreur serveur. Veuillez réessayer plus tard.');
      } else {
        toast.error(`Échec de l'ouverture du PDF : ${error.message || 'Erreur inconnue'}`);
      }
    },
  });

  return {
    uploadPdfFilesMutation,
    deletePdfFileMutation,
    downloadPdfFileMutation,
    generateSecureViewUrlMutation,
  };
};